"use client";

import Link from "next/link";
import { useState } from "react";

import { criarClienteBrowser } from "@/core/supabase/client";
import { mensagemDeErro } from "../_lib/erros";

export default function PaginaRecuperarSenha() {
  const [email, setEmail] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function recuperar(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setCarregando(true);
    const supabase = criarClienteBrowser();
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${location.origin}/auth/confirm?next=/atualizar-senha`,
    });
    if (error) {
      setErro(mensagemDeErro(error));
      setCarregando(false);
      return;
    }
    setEnviado(true);
  }

  if (enviado) {
    return (
      <div className="flex flex-col gap-4 text-center">
        <h1 className="font-[family-name:var(--font-barlow-titulos)] text-xl font-bold uppercase tracking-wider">
          Confira seu e-mail
        </h1>
        <p className="text-sm text-[#8a8a8a]">
          Se existir uma conta para <span className="text-[#ededed]">{email}</span>, você
          receberá um link para redefinir a senha.
        </p>
        <Link href="/entrar" className="text-sm font-medium text-[#ededed] underline underline-offset-4">
          Voltar para entrar
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-center font-[family-name:var(--font-barlow-titulos)] text-xl font-bold uppercase tracking-wider">
        Recuperar senha
      </h1>
      <p className="text-center text-sm text-[#8a8a8a]">
        Informe seu e-mail e enviaremos um link para redefinir sua senha.
      </p>

      <form onSubmit={recuperar} className="flex flex-col gap-3">
        <input
          type="email"
          required
          autoComplete="email"
          placeholder="Seu e-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-[10px] border border-[#2a2a2a] bg-[#1f1f1f] px-4 py-3 text-sm placeholder-[#8a8a8a] outline-none focus:border-[#555]"
        />

        {erro && <p className="text-sm text-[#ff5d5d]">{erro}</p>}

        <button
          type="submit"
          disabled={carregando}
          className="w-full rounded-[10px] bg-white px-4 py-3 text-sm font-semibold text-black transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {carregando ? "Enviando..." : "Enviar link"}
        </button>
      </form>

      <p className="mt-2 text-center text-sm text-[#8a8a8a]">
        Lembrou a senha?{" "}
        <Link href="/entrar" className="font-medium text-[#ededed] underline underline-offset-4">
          Entrar
        </Link>
      </p>
    </div>
  );
}
